"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * MyBuy Backend API
 * ## Release Notes  ### v0.0.1  Work in progress
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.ImageListDataToJSON = exports.ImageListDataFromJSONTyped = exports.ImageListDataFromJSON = void 0;
var runtime_1 = require("../runtime");
function ImageListDataFromJSON(json) {
    return ImageListDataFromJSONTyped(json, false);
}
exports.ImageListDataFromJSON = ImageListDataFromJSON;
function ImageListDataFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'imageUrl': !(0, runtime_1.exists)(json, 'imageUrl') ? undefined : json['imageUrl'],
        'text': !(0, runtime_1.exists)(json, 'text') ? undefined : json['text'],
    };
}
exports.ImageListDataFromJSONTyped = ImageListDataFromJSONTyped;
function ImageListDataToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'imageUrl': value.imageUrl,
        'text': value.text,
    };
}
exports.ImageListDataToJSON = ImageListDataToJSON;
//# sourceMappingURL=ImageListData.js.map